// --------------------------------------------------
//   Imports
// --------------------------------------------------


// React
import React, {useState, useEffect, useContext} from "react";

// Material UI
import { 
  Box,
  CircularProgress,
  Link,
  Stack,
  Typography,
} from "@mui/material";

// Custom Components
import Navigation from "../components/Navigation";

// Custom Contexts
import { UserContext } from "../Contexts";

// Custom Scripts
import { LoadedDataState } from "../scripts/loadedData/loadedData";



// --------------------------------------------------
//   Main Component
// --------------------------------------------------


function DashboardLayout( props ) {

  // State
  const { userData } = useContext( UserContext );

  // Layout
  return (
    <Stack height="100%" gap="48px" minHeight={0}>

      {/* Top Bar */}
      <Stack direction="row" justifyContent='space-between'>
        {
          ( userData.state === LoadedDataState.SUCCESS )
            ? (<>
              {/* User Message */}
              <Typography sx={{
                fontSize: {
                  xs: '1.25rem',
                  sm: '1.5rem',
                  md: '2rem',
                }
              }}>
                Hello, { userData.value?.username ?? 'Anonymous' }!
              </Typography>

              {/* Nav Buttons */}
              <Navigation />
            </>)
            : null
        }
      </Stack>

      {/* Dashboard Page */}
      <Box flexGrow={1}>
        { props.children }
      </Box>

    </Stack>
  );
}



// --------------------------------------------------
//   Export(s)
// --------------------------------------------------

export default DashboardLayout;
